import React from 'react';
import PropTypes from 'prop-types';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';

import css from './DeepLinkJoinModal.module.css';

/**
 * Modal shown when a user clicks a mention notification for a crew they aren't in.
 */
const DeepLinkJoinModal = ({
  isOpen,
  onClose,
  onJoin,
  crewName = '',
  inProgress = false,
}) => {
  return (
    <Modal
      id="DeepLinkJoinModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={() => {}}
    >
      <div className={css.root}>
        <div className={css.iconContainer}>
          <span className={css.icon}>👋</span>
        </div>
        <h2 className={css.title}>Join this Crew to view the post</h2>
        <p className={css.description}>
          This post is in <strong>{crewName || 'this Crew'}</strong>. To view the conversation,
          you'll need to join the Crew first.
        </p>

        <div className={css.actions}>
          <SecondaryButton className={css.cancelButton} onClick={onClose} disabled={inProgress}>
            Maybe later
          </SecondaryButton>
          <PrimaryButton className={css.joinButton} onClick={onJoin} inProgress={inProgress}>
            Join Crew
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

DeepLinkJoinModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onJoin: PropTypes.func.isRequired,
  crewName: PropTypes.string,
  inProgress: PropTypes.bool,
};

export default DeepLinkJoinModal;
